module.exports = __webpack_public_path__ + "r-v3/img/menu_mediashare_white.125c8d35.svg";